import { PayloadAction } from '../../../store.model';
import {
    getSelectedFocusFromRows,
    makeTeamRows,
} from '../focus-history/focus-history.function';
import { ActionType } from '../focus-selector.action';
import { FocusSelectorState } from '../focus-selector.state';

import { FocusSelectorSelectActiveForTeamRow } from './active-for-team-select.action';

export function focusSelectorSelectActiveForTeamRowReducer(
    state: FocusSelectorState,
    action: PayloadAction<ActionType, FocusSelectorSelectActiveForTeamRow>,
): FocusSelectorState {
    const { rowId } = action.payload;

    const updatedRows = makeTeamRows(state.activeFocusesForTeam, rowId);

    const selection = getSelectedFocusFromRows(updatedRows);

    return {
        ...state,
        activeFocusesTeamGrid: {
            ...state.activeFocusesTeamGrid,
            rows: updatedRows,
            sortDefs: [...state.activeFocusesTeamGrid.sortDefs],
            selection,
        },
    };
}
